import React from 'react';
import './clickbox-menu.scss';

import { Clickbox } from '../clickbox/clickbox';

export const ClickboxMenu = ({ menuItems, aria, ...props }) => {
  const menuDocuments = menuItems;
  return (
    <ul className="clickbox-menu" data-testid="clickbox-menu" role="menu" aria-label={aria ? aria : 'Menu'}>
      {menuDocuments.map((item, i) => {
        return (<li key={i}><Clickbox
          text={item.item}
          path={item.path} 
          isDownload={item.isDownload ? item.isDownload : false}
          newTab={item.newTab ? item.newTab : false}
        /></li>);
      })}
    </ul>
  );
};